
/* 
 * Export component file to be used on project
*/

import  PaymentListItem from './PaymentListItem.js';
export default PaymentListItem;
